import { Grid, IconButton, Tooltip } from "@mui/material";
import {} from "@mui/styles";
import React, { FC, useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { getDispatchFeedEventRequest } from "../../../../actions";
import { DispatchEventFeedModel } from "../../../../reducers/states/dispatch-event-feed-state";
import {
  IncidentDispatch,
  UpdateIncidentDispatchRequest,
  VccIncidentModel,
} from "../../../../reducers/states/vcc-incident";
import AdditionalDetailsModal from "../../../integrated-dispatch-feed/additional-details-modal";
import { IRootReducer } from "../../../../reducers";
import { ZoomOutMap } from "@mui/icons-material";
import { AgencyChip } from "../../../common/agency-chip";
import { AgencyCode } from "../../../../reducers/states/agency";

interface AssociatedEventsSimpleProps {
  props: {
    fromIncidentPage?: boolean;
    dispatchAddtlInfo?: DispatchEventFeedModel;
    incident: VccIncidentModel;
    associatedIdRequests?: UpdateIncidentDispatchRequest[];
  };
}

const AssociatedEventsItems: FC<AssociatedEventsSimpleProps> = ({ props }) => {
  const dispatch = useDispatch();
  const [incident, setIncident] = useState({} as VccIncidentModel);
  const [incidentDispatches, setIncidentDispatches] = useState([] as IncidentDispatch[]);
  const [isDetailsModalOpen, setIsDetailsModalOpen] = useState(false);

  const dispatchStore = useSelector((state: IRootReducer) => state.dispatchEventFeedReducer.dispatchEvent);

  useEffect(() => {
    if (props.incident) {
      setIncident(props.incident);
    }
  }, [props.incident]);

  useEffect(() => {
    if (incident?.dispatchEvents && incident?.dispatchEvents?.length > 1) {
      // If multiple associated dispatches, sort by most recent and status
      let openEvents = incident.dispatchEvents?.filter((e) => e.isOpen);
      let closedEvents = incident.dispatchEvents?.filter((e) => !e.isOpen);
      let sortedOpenEvents = openEvents?.sort(
        (d1, d2) => new Date(d2.startTime).getTime() - new Date(d1.startTime).getTime(),
      );

      setIncidentDispatches([...sortedOpenEvents, ...closedEvents]);
    } else {
      setIncidentDispatches(incident.dispatchEvents ?? []);
    }
  }, [incident?.dispatchEvents]);

  const handleOpenAdditionalDetails = (incidentDispatchId: string) => {
    dispatch(getDispatchFeedEventRequest(incidentDispatchId));
    setIsDetailsModalOpen(true);
  };

  return (
    <>
      {incidentDispatches?.map((dispatch: IncidentDispatch) => (
        <Grid key={dispatch.id} item pr={1}>
          <AgencyChip
            agency={dispatch.agency as AgencyCode}
            isClosed={!dispatch.isOpen}
          />
          <Tooltip title={"Click to Open Additional Details"}>
            <IconButton
              edge="end"
              onClick={() => {
                handleOpenAdditionalDetails(dispatch.id);
              }}
              size="large"
              sx={{ padding: "0 3px 0 3px" }}
            >
              <ZoomOutMap />
            </IconButton>
          </Tooltip>
        </Grid>
      ))}

      <AdditionalDetailsModal
        props={{
          isOpen: isDetailsModalOpen,
          idfEvent: dispatchStore,
          handleClose: () => setIsDetailsModalOpen(false),
        }}
      />
    </>
  );
};

export default AssociatedEventsItems;
